module.exports = __webpack_public_path__ + "img/mobile-neck_28x838.af589777.png";